import { PageHeader, Table } from "@velocity-ehs/component-library";
import { Column } from "primereact/column";
import { ChangeEvent, useCallback, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useGetPaginatedContractingCompanies } from "../../../hooks/useGetPaginatedContractingCompanies";
import { SortDirection } from "../../supportFunctions/graphql/Queries";
import { ContractingCompanySidebar } from "./ContractingCompanySidebar";

const defaultTableParams = {
  first: 0,
  page: 0,
  rows: 20,
  sortField: "name",
  sortOrder: SortDirection.ASC,
  filters: {
    name: {
      value: null,
    },
  },
};

const ContractingCompaniesList = () => {
  const { t } = useTranslation();

  const [isSliderVisible, setIsSliderVisible] = useState(false);

  const [selectedContractingCompany, setSelectedContractingCompany] = useState<{
    id: string;
    name: string;
  } | null>(null);

  const [lazyParams, setLazyParams] = useState(defaultTableParams);
  const { contractingCompanies, pagination, loading } =
    useGetPaginatedContractingCompanies(lazyParams);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  useEffect(() => {
    pagination.totalElements && setTotalRecords(pagination.totalElements);
  }, [pagination.totalElements]);

  const handleGlobalSearch = useCallback(
    (event: ChangeEvent<HTMLInputElement>) =>
      setLazyParams((previous) => ({
        ...previous,
        filters: {
          ...previous.filters,
          name: {
            value: event.target.value,
          },
        },
      })),
    []
  );

  const handleSelection = (event: { data: { id: string; name: string } }) => {
    setSelectedContractingCompany(event.data);
    setIsSliderVisible(true);
  };

  const handleCloseSlider = () => {
    setSelectedContractingCompany(null);
    setIsSliderVisible(false);
  };

  return (
    <>
      <PageHeader
        title={t("universal_contracting_companies")}
        navigationTree={[
          { text: `Accelerate ${t("universal_Home")}`, href: "/" },
          { text: t("universal_contracting_companies"), href: "" },
        ]}
        primaryButton={{
          label: t("universal_Add"),
          id: "addContractingCompany",
          visible: true,
          onClick: () => setIsSliderVisible(true),
        }}
      />
      <div className="card__fullContent">
        <Table
          data={contractingCompanies}
          params={lazyParams}
          totalRecords={totalRecords}
          selectionMode="single"
          onRowSelect={(e: { data: { id: string; name: string } }) =>
            handleSelection(e)
          }
          onPage={setLazyParams}
          onSort={setLazyParams}
          onGlobalSearch={handleGlobalSearch}
          isLoading={loading}
        >
          <Column field="name" header={t("universal_Name")} sortable />
        </Table>
      </div>
      <ContractingCompanySidebar
        closeSlider={handleCloseSlider}
        isVisible={isSliderVisible}
        selectedContractingCompany={selectedContractingCompany}
        setSelectedContractingCompany={setSelectedContractingCompany}
      />
    </>
  );
};

export default ContractingCompaniesList;
